import { inRange, toUpper } from 'lodash';
import moment from 'moment';
import { SUMMER_DATE_END, SUMMER_DATE_START } from 'Tracking/constants';
type TrackingTransport = 'with_transport' | 'without_transport';
export const WITH_TRANSPORT = 'with_transport';
export const WITHOUT_TRANSPORT = 'without_transport';
const NO_DEPARTURE_CITY = 'NO';
export const TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare',
};
export function getTrackingTransport(departureCityCode?: string): TrackingTransport {
  return departureCityCode && toUpper(departureCityCode) !== NO_DEPARTURE_CITY
    ? WITH_TRANSPORT
    : WITHOUT_TRANSPORT;
}
export function getDepartureCityCode(departureCityCode?: string): string {
  return departureCityCode && toUpper(departureCityCode) !== NO_DEPARTURE_CITY
    ? departureCityCode
    : WITHOUT_TRANSPORT;
}
export function getDepartureCityName(
  departureCityCode?: string,
  departureCityName?: string,
): string {
  return departureCityName && departureCityCode && toUpper(departureCityCode) !== NO_DEPARTURE_CITY
    ? departureCityName
    : '';
}
export function isSummer(date: Date): boolean {
  return inRange(Number(moment(date).format('MMDD')), SUMMER_DATE_START, SUMMER_DATE_END);
}
